// Email Popup JavaScript
class EmailPopup {
  constructor() {
    this.popupOverlay = document.getElementById('email-popup-overlay');
    this.closeBtn = document.querySelector('.email-popup-close');
    this.popupForm = document.querySelector('.email-popup-form');
    
    if (this.popupOverlay && this.closeBtn && this.popupForm) {
      // Get options from data attributes
      this.options = {
        delay: parseInt(this.popupOverlay.dataset.delay) || 5000,
        successRedirect: this.popupOverlay.dataset.successRedirect || null
      };
      
      this.init();
    }
  }
  
  init() {
    // Check if form was successfully submitted
    const successMessage = this.popupForm.querySelector('.popup-success-message');
    if (successMessage) {
      // Form was submitted successfully, show popup with success message
      this.popupOverlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      
      // Don't auto-hide success message - let user manually dismiss
      this.bindEvents();
      return;
    }
    
    // Check if popup should be shown normally
    const popupShown = localStorage.getItem('kryozen-popup-shown');
    const popupDismissed = localStorage.getItem('kryozen-popup-dismissed');
    
    if (!popupShown && !popupDismissed) {
      this.showPopup();
    }
    
    this.bindEvents();
  }
  
  showPopup() {
    setTimeout(() => {
      this.popupOverlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }, this.options.delay);
  }
  
  hidePopup() {
    this.popupOverlay.style.display = 'none';
    document.body.style.overflow = '';
  }
  
  hidePopupPermanently() {
    this.hidePopup();
    localStorage.setItem('kryozen-popup-dismissed', 'true');
  }
  
  bindEvents() {
    // Close button
    this.closeBtn.addEventListener('click', () => this.hidePopup());
    
    // Click outside to close
    this.popupOverlay.addEventListener('click', (e) => {
      if (e.target === this.popupOverlay) {
        this.hidePopup();
      }
    });
    
    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popupOverlay.style.display === 'flex') {
        this.hidePopup();
      }
    });
    
    // Form submission
    this.popupForm.addEventListener('submit', (e) => this.handleSubmit(e));
  }
  
  handleSubmit(e) {
    const submitBtn = this.popupForm.querySelector('.popup-submit-btn');
    const email = this.popupForm.querySelector('input[name="contact[email]"]').value;
    
    // Show loading state
    const originalText = submitBtn.textContent;
    submitBtn.textContent = 'Signing up...';
    submitBtn.disabled = true;
    
    // Store email for success tracking and mark as permanently shown
    localStorage.setItem('kryozen-email-collected', email);
    localStorage.setItem('kryozen-popup-shown', 'true');
    localStorage.setItem('kryozen-popup-dismissed', 'true');
    
    // Let the native Shopify form handle the submission
    // The form will reload the page and show success/error messages
  }
  
  showSuccessMessage() {
    this.popupForm.innerHTML = `
      <div style="text-align: center; padding: 20px;">
        <div style="font-size: 48px; margin-bottom: 15px;">✅</div>
        <h3 style="color: #10B981; margin-bottom: 10px; font-size: 24px;">Success!</h3>
        <p style="margin: 0; color: #666;">Thank you for signing up! Check your email for your discount code and download link.</p>
      </div>
    `;
    setTimeout(() => this.hidePopup(), 3000);
  }
  
  showErrorMessage(message) {
    const errorDiv = document.createElement('div');
    errorDiv.style.cssText = 'color: #EF4444; text-align: center; margin-top: 10px; padding: 10px; background: #FEE2E2; border-radius: 6px;';
    errorDiv.textContent = message;
    
    // Remove existing error messages
    const existingError = this.popupForm.querySelector('.popup-error');
    if (existingError) {
      existingError.remove();
    }
    
    errorDiv.className = 'popup-error';
    this.popupForm.appendChild(errorDiv);
    
    // Remove error after 5 seconds
    setTimeout(() => {
      if (errorDiv.parentNode) {
        errorDiv.remove();
      }
    }, 5000);
  }
}

// Make EmailPopup available globally
window.EmailPopup = EmailPopup;

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Check if popup elements exist before initializing
  if (document.getElementById('email-popup-overlay')) {
    window.emailPopup = new EmailPopup();
  }
});